@if (form!=null) {
  <form [formGroup]="form">
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Email</label>
        <input class="form-control" type="email" placeholder="email@teste.com" formControlName="email">
        @if (!this.form.get('email').valid && (this.form.get('email').touched || this.form.get('email').dirty)) {
          <div>
            @if (form.get('email').hasError('required')) {
              <small class="text-danger">
                Campo Obrigatório
              </small>
            }
            @if (form.get('email').hasError('email')) {
              <small class="text-danger">
                Email Inválido
              </small>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Celular</label>
        <input class="form-control" type="text" placeholder="(41) 999999999" formControlName="celular" mask="(00) 000000000">
        @if (!this.form.get('celular').valid && (this.form.get('celular').touched || this.form.get('celular').dirty)) {
          <div>
            @if (form.get('celular').hasError('required')) {
              <small class="text-danger">
                Campo Obrigatório
              </small>
            }
            @if (form.get('celular').hasError('minlength')) {
              <small class="text-danger">
                Celular Inválido
              </small>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row mt-5">
      <div class="input-group col-md-3">
        <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
        <div class="input-group-append">
          <button class="btn btn-success" type="button" (click)="salvar()" [disabled]="!form.valid || loading">
            Salvar
            @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </div>
    </div>
    @if (!this.form.get('assinatura').valid && (this.form.get('assinatura').touched || this.form.get('assinatura').dirty)) {
      <div>
        @if (form.get('assinatura').hasError('required')) {
          <small class="text-danger">
            Campo Obrigatório
          </small>
        }
      </div>
    }
    @if (msgErro!=null) {
      <div class="msgErroForm">
        {{msgErro}}
      </div>
    }
  </form>
}